$.fn.getSelectedGridRows = function () {
    /// <summary>Gets the selected rows for a Kendo grid</summary>
    /// <returns type="Array">Returns an array for selected data items for the grid element</returns>

    var me = $(this);

    if (me.hasClass('cGrdWrap'))
        me = $('.cGrd', me);

    let grid = me.getKendoGrid();
    return grid ? grid.getSelectedRows() : [];
}
$.fn.getSelectedGridRowIds = function () {
    /// <summary>Gets the selected rows for a Kendo grid</summary>
    /// <returns type="Array">Returns an array for selected data items for the grid element</returns>

    return this.getGrid().data("uids") || [];
}
$.fn.refreshGridDataSource = function () {
    /// <summary>Refreshes a grid view data source, this method will work when called on the grid or the grid wrapper</summary>
    /// <returns type="JQuery">Kendo grid view</returns>

    this.each(function () {
        var me = $(this).getGrid();
        me.refreshDataSource();
    });
    return this;
}
$.fn.getGrid = function () {
    /// <summary>Gets the grid view element, this method will work when called on the grid wrapper or from inside it</summary>
    /// <returns type="JQuery">Kendo grid view</returns>

    var me = $(this);

    if (me.hasClass('cGrd')) {
        me = $(this);
    }

    if (me.hasClass('cGrdWrap')) {
        me = $('.cGrd', me);
    }
    else if (!me.hasClass('cGrd')) {
        me = me.closest('.cGrd');
    }

    return me;
}
cafm.grids = {
    render: function (o) {
        /// <summary>Creates a Kendo grid</summary>
        /// <param name="o" type="Object">The grid options</param>

        let gridWrap = $('#{0}'.format(o.ClientId)), gridEl = $('.cGrd', gridWrap), gridOptions, gridHeight,
            selectable, visibleColumns, ds, rowCommands = [], criteria = o.Criteria,
            checkboxes = o.Selectable == cafm.enums.Selectable.Checkbox;
        if (!gridEl.length) return;
        if (!gridEl.getCriteria() && criteria) {

            gridEl.setCriteria(criteria);
        }
        else {

            criteria = gridEl.getCriteria();
        }
        
        if (isTouch && o.Selectable == cafm.enums.Selectable.Multiple) {
            o.Selectable = cafm.enums.Selectable.Disabled;
            gridEl.data('uids', []);
            setTimeout(() => {
                gridEl.touchTap('tr[role="row"]', e => {
                    let row = $(e.currentTarget),
                        gridView = row.getGrid().data('kendoGrid');
                    gridView.toggleRow(row);
                    gridView.trigger('change');
                });
            }, 500);
        }

        selectable = o.Selectable > cafm.enums.Selectable.Disabled ? cafm.enums.getEnumKey(cafm.enums.Selectable, o.Selectable).toLowerCase() : false;

        if (selectable) {
            gridEl.data('selectable', o.Selectable);
            gridEl.data('uids', []);
            if (selectable == 'checkbox') selectable = false;
        }

        gridEl.data('options', o);

        if (o.AutoSetHeight) {

            let getGridHeight = function () {

                let shH = $('#searchHeading').outerHeight() || 0, subH = $('#sub-header').outerHeight() || 0;
                return cafm.panel.getContentPaneHeight() - shH - subH - 3; // take away the search heading and then 2 for the grid borders (top, bottom)
            }

            gridHeight = getGridHeight();

            let resizeGrid = function() {

                if (window.gridResizeTimeout) {

                    clearTimeout(window.gridResizeTimeout);
                }

                window.gridResizeTimeout = setTimeout(function () {

                    let dataArea = gridEl.find(".k-grid-content"),
                        newHeight = getGridHeight(),
                        diff = gridEl.innerHeight() - dataArea.innerHeight();
                    gridEl.height(newHeight);
                    dataArea.height(newHeight - diff);
                }, 250);
            }

            $(window).resize(resizeGrid);
        }
        else {

            gridHeight = o.Height;
        }
                
        // take the visible columns
        visibleColumns = cafm.util.where(o.Columns, col => {
            col.title = cafm.util.encodeHtml(col.title);
            return col.visible;
        });

        // create the datasource
        ds = cafm.ds.createSearchDataSource({
            element: gridEl,
            control: () => {
                return gridEl.data('kendoGrid');
            },
            options: o,
            criteria: criteria,
            dataSourceChanged: cafm.grids.dataSourceChanged
        });

        $.each(visibleColumns, (i, col) => {            
            if (col.editor && isStr(col.editor)) {
                col.editor = cafm.util.getReference(col.editor);
                if (!o.Editable) o.Editable = true;
            }
            if (col.editable === true || col.editable === false) {
                let editableFlag = col.editable;
                col.editable = () => editableFlag;
            }   
        });

        let pageable;
        if (o.EnablePaging) {

            if (o.ItemName && o.CollectionName) {

                o.PagerMessage = cafm.res.str.TemplatePagerMessage + ' ' + o.CollectionName.toLocaleLowerCase();
                o.PagerSinglePageMessage = '{0} ' + o.CollectionName;
                o.PagerSingleMessage = '{0} ' + o.ItemName;
            }
            else {

                o.PagerMessage = cafm.res.str.TemplatePagerMessage + ' ' + cafm.res.str.LabelItems.toLocaleLowerCase();
                o.PagerSinglePageMessage = '{0} ' + cafm.res.str.LabelItems.toLocaleLowerCase();
                o.PagerSingleMessage = '{0} ' + cafm.res.str.LabelItem.toLocaleLowerCase();
            }

            pageable = {
                dataSource: ds,
                messages: {
                    display: o.PagerMessage
                },
                change: function (e) {

                    e.sender.dataSource.grid.element.data('page', e.index);

                    let c = gridEl.getCriteria();
                    if (c && !o.UseServerPaging) {

                        cafm.ds.currentPage.set(c, e.index);
                    }
                }
            };
        }
        else {
            pageable = false;
        }

        gridOptions = {

            dataSource: ds,
            groupable: o.Groupable,
            sortable: o.Sortable,
            pageable: pageable,
            reorderable: o.Reorderable,
            resizable: o.Resizeable,
            selectable: checkboxes ? false : selectable,
            scrollable: o.Scrollable,
            columns: visibleColumns,
            navigatable: o.EnableKeyboardNavigation,
            autoBind: o.AutoBind,
            height: gridHeight,
            change: cafm.grids.rowSelected,
            columnReorder: cafm.grids.columnReordered,            
            messages: { commands: {} },
            detailTemplate: o.DetailTemplateClientId ? kendo.template($('#' + o.DetailTemplateClientId).html()) : null,
            dataBound: function (e) {

                let grd = e.sender,
                    total = e.sender.dataSource ? e.sender.dataSource.total() : 0,
                    onDataBound = o.OnDataBound;

                // setup checkboxes if in checkbox selection mode
                if (checkboxes) {
                    gridEl.find('input[type="checkbox"]').each((i, c) => {
                        let chkId = cafm.guid.newGuid();
                        $(c).attr('id', chkId).siblings('label').attr('for', chkId);
                    });
                }

                if (o.PageSize > 0) {

                    cafm.util.modifyPager(gridWrap, e.sender.dataSource, o);
                }

                if (onDataBound) {

                    cafm.handlers.exe(onDataBound, e, o);
                }

                if (selectable || checkboxes) {

                    let uids = gridEl.data('uids');
                    let hasSelectedCheckbox;

                    if (gridEl.data('initialising') && cafm.util.hasItem(o.SelectedIds)) {
                        if (!uids) uids = [];
                        grd.tbody.find("> tr").each((i, row) => {
                            let dataItem = grd.dataItem(row);
                            if (cafm.util.exists(o.SelectedIds, dataItem.id))
                                uids.push(dataItem.id);
                        });
                    }

                    if (o.BoundViewModelCollection) {

                        let selectedFieldName;
                        if (checkboxes) selectedFieldName = grd.columns[0].field;
                        else selectedFieldName = 'Selected';

                        grd.tbody.find('> tr').each((i, row) => {
                            row = $(row);
                            let dataItem = grd.dataItem(row);
                            if (dataItem.get(selectedFieldName) === true) {
                                grd.selectRow(row);
                                hasSelectedCheckbox = true;
                            }
                        });
                    }
                    else if (cafm.util.hasItem(uids)) {
                        grd.tbody.find('> tr').each((i, row) => {
                            row = $(row);
                            let dataItem = grd.dataItem(row);
                            if (cafm.util.exists(uids, dataItem.id)) {
                                grd.selectRow(row);
                                hasSelectedCheckbox = true;
                            }
                        });
                    }

                    if (checkboxes) {
                        let hasUnchecked = grd.tbody.find('.grid-row-chk input:not(:checked)').length > 0;
                        grd.thead.find('.grid-header-chk input').setChecked(hasSelectedCheckbox && !hasUnchecked, true);
                    }
                }

                // setup row commands
                if ($('[data-rowcommand]', grd.tbody).length) {

                    cafm.grids.helpers.setupRowCommands(grd);
                }

                if (gridEl.data('initialising')) {

                    gridEl.removeData('initialising');
                }
            }
        };

        if (o.AllowInlineCreate) {

            gridOptions.toolbar = [{ name: 'create', text: cafm.res.str.LabelAdd }];
        }

        if (cafm.util.hasStringVal(o.Editable)) {

            gridOptions.editable = {
                mode: o.Editable,
                confirmation: false,
                createAt: 'bottom'
            }

            if (!o.UseCustomCommandsTemplate) {
                if (o.Editable == cafm.res.consts.GridEditableMode_Inline) {

                    gridOptions.messages.commands.edit = cafm.res.str.LabelEdit;
                    rowCommands.push('edit');
                }

                if (o.AllowInlineDelete) {

                    gridOptions.messages.commands.destroy = cafm.res.str.LabelRemove;
                    rowCommands.push('destroy');
                }

                if (cafm.util.hasItem(rowCommands)) {

                    gridOptions.columns.push({ command: rowCommands, title: '&nbsp;' });
                }
            }

            if (o.OnEdit) {
                gridOptions.edit = cafm.util.getReference(o.OnEdit);
            }
            else {
                gridOptions.edit = args => {
                    args.sender.element.find("input[type=text]").attr("autocomplete", cafm.guid.newGuid())
                }
            }

            // refresh grid on cancel to ensure checkbox selection
            if (checkboxes && !gridOptions.cancel) {
                gridOptions.cancel = args => {
                    cafm.util.callFunctionAsync({
                        func: () => {
                            args.sender.refresh();
                            cafm.util.callFunction(o.OnCancel, args);
                        }
                    });
                }
            }

            // ensure checkbox selection when switching edits on rows - workaround for issue where cell state (even for non editable cells) is reset but data bound does not appear to be fired
            gridOptions.beforeEdit = args => {
                if (o.BoundViewModelCollection && checkboxes) {
                    let grd = args.sender,
                        pvm = grd.element.getParentViewModel(),
                        selectedFieldName = kgrid.columns[0].field,
                        pkField = o.PrimaryKeyField.Name;
                    if (pvm) {
                        grd.tbody.find("tr").each((i, el) => {
                            let row = $(el),
                                dataItem = grd.dataItem(row),
                                checkbox = row.find(".grid-row-chk input"),
                                viewModelItem = cafm.util.findByFieldValue(pvm[o.BoundViewModelCollection], pkField, dataItem.id);
                            if (viewModelItem && viewModelItem[selectedFieldName] == true && (!checkbox.isChecked() || !dataItem[selectedFieldName])) {
                                dataItem[selectedFieldName] = true;
                                checkbox.setChecked(true, true);
                            }
                        });
                    }
                }
                cafm.util.callFunction(o.OnBeforeEdit, args);
            }
        }
        
        gridEl.data('initialising', true);

        if (!o.AutoBind) {
            gridEl.hide();
            if (o.ShouldAutoSearchEvalFunction) {
                let autoSearch = cafm.util.callFunction(o.ShouldAutoSearchEvalFunction);
                if (!autoSearch) {
                    cafm.grids.showSelectFiltersFirstMessage(o);
                } else {
                    gridOptions.autoBind = true;
                }
            }
        }

        let kgrid = gridEl.kendoGrid(gridOptions).data('kendoGrid');
        gridEl.setDataSource(kgrid.dataSource);
        kgrid.dataSource.grid = kgrid;
        gridEl.data('page', criteria && criteria.Page ? criteria.Page : 1);

        if (checkboxes) {
            //bind click event to the checkbox
            kgrid.table.on("click.cafm", '.grid-row-chk input', cafm.grids.rowSelectedByCheckBox);
            kgrid.thead.on("click.cafm", '.grid-header-chk input', cafm.grids.selectAllByCheckBox);            
        }
    },
    rowSelected: function (e) {
        /// <summary>Handles row selection for a grid</summary>
        /// <param name="e" type="Object">Selection event object</param>

        let grdEl = e.sender.element,
            uids = grdEl.data('uids');

        $.each(e.sender.items(), function (i, item) {
            let row = $(item),
                dataItem = e.sender.dataItem(row),
                ind = uids.indexOf(dataItem.id);
            if (row.hasClass('k-state-selected')) {
                if (ind == -1) uids.push(dataItem.id);
            }
            else if (ind > -1)
                uids.splice(ind, 1);
        });
        cafm.handlers.exe(grdEl.data('options').OnSelectionChanged, e, grdEl.getSelectedGridRows());
    },
    rowSelectedByCheckBox: function (args) {

        let checkbox = $(args.currentTarget),
            row = checkbox.closest('tr'),
            kgrid = row.closest('.k-grid').getKendoGrid(),
            opts = kgrid.element.data('options'),
            isChecked = checkbox.isChecked();

        let res = cafm.handlers.exe(opts.OnCheckboxSelectionChanging, kgrid.dataItem(row), kgrid.getSelectedRows(), isChecked, row);
        if (res === false) {
            checkbox.setChecked(!isChecked, true);
            return;
        }
        if (checkbox.prop('disabled')) return;

        kgrid.toggleRow(row);

        // update bound view model collection..
        if (opts.BoundViewModelCollection) {

            let selectedFieldName = kgrid.columns[0].field, dataItem = kgrid.dataItem(row);
            dataItem[selectedFieldName] = isChecked;

            // update view model..
            let pvm = kgrid.element.getParentViewModel();
            if (pvm) {

                let pkField = opts.PrimaryKeyField.Name,
                    viewModelItem = cafm.util.find(pvm.get(opts.BoundViewModelCollection), item => {
                        return item[pkField] == dataItem.id;
                    });
                if (viewModelItem)
                    viewModelItem.set(selectedFieldName, isChecked);
            }
        }
        if (kgrid.thead.find('.grid-header-chk:visible').length) {
            cafm.util.callFunctionAsync({
                func() {
                    let hasUnchecked = kgrid.tbody.find('.grid-row-chk input:not(:checked)').length > 0;
                    kgrid.thead.find('.grid-header-chk input').setChecked(!hasUnchecked, true);
                },
                key: 'gridallcheckbox',
                timeout: 100
            })
        }

        cafm.handlers.exe(opts.OnSelectionChanged, kgrid.dataItem(row), kgrid.getSelectedRows(), isChecked, row);
    },
    selectAllByCheckBox(e) {

        let chk = $(e.currentTarget),
            grid = chk.closest('.k-grid');

        if (chk.prop('disabled')) return;

        if (chk.isChecked()) {
            grid.find('tbody .grid-row-chk input:not(:checked)').click();
        }
        else {

            grid.find('tbody .grid-row-chk input:checked').click();
        }
    },
    columnReordered(e) {

        let onColsReordered = e.sender.element.data('columnsReordered');
        if (isFunc(onColsReordered)) {
            onColsReordered(e);
        }
    },
    dataSourceChanged(e) {

        if (e.sender.grid) {
            let ge = $(e.sender.grid.element);
            // only fire datasource changed when we're not already going off to the server
            if (!ge.data('initialising') && !ge.data('requestActive') && e.sender.grid.element) {
                var onDataSourceChanged = e.sender.grid.element.data('dataSourceChanged');
                if (isFunc(onDataSourceChanged)) {
                    onDataSourceChanged(e);
                }
            }
            ge.removeData('requestActive');
        }
    },
    showEmptyGrid(o) {
        /// <summary>Shows empty grid message and hides the empty grid</summary>
        /// <param name="o" type="Object">The grid options</param>        
        if (o.NoItemsMessage) {
            cafm.grids.showMessageInMsgPanel(o, cafm.enums.MessageType.Warning, o.NoItemsMessage);
        }
    },
    showSelectFiltersFirstMessage(o) {
        /// <summary>Shows message asking User to select filter first</summary>
        /// <param name="o" type="Object">The grid options</param>        
        cafm.grids.showMessageInMsgPanel(o, cafm.enums.MessageType.Information, cafm.res.str.TextSelectFiltersToPerformSearch);
    },
    showMessageInMsgPanel(o,t,m) {
        /// <summary>Shows empty grid message and hides the empty grid</summary>
        /// <param name="o" type="Object">The grid options</param>        
        /// <param name="o" type="Object">The message type</param>        
        /// <param name="o" type="Object">The message</param>        
        var grdWrap = $('#{0}'.format(o.ClientId));
        var ge = $('.cGrd', grdWrap);
        ge.hide();
        $('.msgPnl', grdWrap).showMessage({
            Type: t,
            Title: m
        });
    },
    columnsReordered(e) {

        let vm = $('#mainFilterSet').getViewModel();        
        let col = cafm.util.find(vm.VisibleColumns, vc => {
            return isStr(vc) && vc == e.column.field || vc.value == e.column.field;
        });
        if (col) {
            let cols = vm.get('VisibleColumns');
            cols.splice(e.oldIndex, 1);
            cols.splice(e.newIndex, 0, col);
            vm.set('VisibleColumnsChanged', false);
            vm.set('SuppressVisibleColumnsChanged', true);
            vm.set('VisibleColumns', cols);
            vm.set('SuppressVisibleColumnsChanged', false);
            cafm.grids.saveGridState(vm);
        }
    },
    ensureGridState(e) {

        if (isNullOrUndefined(e.sender.grid)) {
            return;
        }

        let isPageChange = e.sender.grid.element.data('page') != e.sender.page();
        if (!isPageChange) {
            let vm = $('#mainFilterSet').getViewModel(),
                sortOptions = [], groupOptions = [], sort = e.sender.sort();
            if (sort) {
                sort.forEach(sortOption => {
                    sortOptions.push({
                        Field: sortOption.field,
                        Direction: cafm.ds.toSortDirEnum(sortOption.dir)
                    });
                });
            }
            let group = e.sender.group();
            if (group) {
                group.forEach(groupOption => {
                    groupOptions.push({
                        Field: groupOption.field,
                        Direction: cafm.ds.toSortDirEnum(groupOption.dir)
                    });
                });
            }
            if (vm) {
                vm.set({
                    SortOptions: sortOptions,
                    GroupOptions: groupOptions
                });
                cafm.grids.saveGridState(vm);
            }
        }
    },
    saveGridState(gridState, callback, tout) {

        let vc = gridState.get('VisibleColumns');
        // transform objects straight out of the field chooser
        if (cafm.util.hasItem(vc) && vc[0] && vc[0].value) {
            vc = cafm.util.selectValue(vc, 'value');
        }
        let actionOptions = {
            url: cafm.url.api('GridState/Save'),
            values: {

                CategoryKey: gridState.get('CategoryKey'),
                SearchKey: gridState.get('SearchKey'),
                VisibleColumns: vc,
                SortOptions: gridState.get('SortOptions'),
                GroupOptions: gridState.get('GroupOptions')
            },
            statusCodeFuncs: {
                204() {

                    if (isFunc(callback)) {

                        callback();
                    }
                }
            }
        };

        if (cafm.grids.saveStateTimeout) {

            clearTimeout(cafm.grids.saveStateTimeout);
        }

        cafm.grids.saveStateTimeout = setTimeout(() => {
            cafm.actions.execute(actionOptions);
        }, isNum(tout) ? tout : 2000);
    },
    getSearchGridData() {

        var ds = cafm.grids.getSearchGridDataSource();
        return ds ? ds.data() : [];
    },
    getSearchGridDataSource() {

        return $('#{0}'.format(cafm.res.consts.ElementId_SearchGrid)).getDataSource();
    },
    refreshSearchGrid() {
        
        $('#{0}'.format(cafm.res.consts.ElementId_SearchGrid)).refreshGridDataSource();
    },
    editors: {
        checkboxEditor(container, options) {

            $('<span class="grid-checkbox-editor"><input type="checkbox" id="{1}" name="{0}" data-type="boolean" data-bind="checked: AutoBind" class="k-checkbox"><label for="{1}" class="k-checkbox-label"></label></span>'.format(options.field, cafm.guid.newGuid())).appendTo(container);
        },
        dropDownEditor(container, options) {
            let ddo = options.dropDownOptions,
                select = $('<select class="cfControl" data-text-field="text" data-value-field="value" data-bind="value:' + options.field + '"/>');            
            if (ddo.required) {
                select.attr('required', '');
                if (ddo.validationMessage) {
                    select.attr('validationMessage', ddo.validationMessage);
                }
            }
            return select.appendTo(container).kendoDropDownList(options.dropDownOptions);
        }
    },
    helpers: {
        setupRowCommands: function (grid) {
            /// <summary>Setup row command event handlers</summary>
            /// <param name="grid" type="kendo.Grid">The grid wrapper</summary>

            grid.wrapper.off('click.rowcommand').on('click.rowcommand', '[data-rowcommand]', args => {
                let btn = $(args.currentTarget),
                    rowCommand = btn.data('rowcommand'),
                    dataItem = grid.dataItem(btn.closest('tr'));
                if (!rowCommand) return;
                return cafm.util.callFunction(rowCommand, dataItem, btn);
            });
        }
    }
}